import { CategoryAverage, ReportCardGradesStandards, ReportCardGradesTerm } from '../../student360/grades/grades.model';
import { Profile } from '../profile-table/profile.model';
import { System } from '../System';
import { AttendanceDetails } from './attendance-details.model';
import { CourseTerm } from './course-term.model';
import { Enrollment } from './enrollment.model';

export class CourseSchedule {

	// Properties
	// int MaxPeriod: static;
	Id: number;
	SchoolId: number;
	SiteYearId: number;
	SiteSectionId: number;
	SiteSectionIds: number[];
	Meets: string;
	Dropped: string;
	Term: string;
	Course: string;
	AbbreviatedTitle: string;
	Teacher: string;
	TeacherEmail: string;
	TeacherName: string;
	TeacherMemId: number;
	Room: string;
	UsedForGrading: boolean;
	SubjectCode: string;
	Section: string;
	StartEndTime: string;
	SchoolName: string;
	TeacherId: number;
	SubjectTermType: string;
	StartPeriod: number;
	ConsecutivePeriod: number;
	Absences: number;
	Tardies: number;
	AttendanceDetails: AttendanceDetails[];
	CalendarAssignments: any[];
	CourseTerms: CourseTerm[];
	ReportCardGradesTerms: ReportCardGradesTerm[];
	ReportCardGradesStandards: ReportCardGradesStandards[];
	CreditEarned: number;
	CreditAttempted: number;
	ShowTraditionalTab: boolean;
	ShowStandardTab: boolean;
	Curriculum: string;
	Description: string;
	IsCurrentLocation: boolean;
	IsHomeRoom: boolean;
	CourseProfile: Profile[];
	TeacherProfile: Profile[];
	StaffPicture: any[];
	CourseStartDate: Date = null;
	CourseEndDate: Date = null;
	DisplayDroppedClasses: boolean;
	EntryDate: Date = null;
	WithdrawalDate: Date = null;
	DroppedDate: Date = null;
	GradingCycle: string;
	PeriodDayCode: string;
	ShowOnGradesPage: boolean;
	TeamCode: string;
	CategoryAverages: CategoryAverage[];
	CategoriesTerms: any;
	AttendanceType: string;

	// Local Properties
	private _showSchool: { [key: number]: boolean } = {};
	private _entryDate: Date;
	private _droppedDate: Date;
	TempReportCardGradesTerms: ReportCardGradesTerm[];

	// Methods
	getShowSchool(studentEnrollment: Enrollment): boolean {
		// POST: determines if the school should be shown with the name

		// If no student enrollment is supplied, always return false
		if (!studentEnrollment) {
			return false;
		}

		// Checking if we've set this one yet
		if (this._showSchool[studentEnrollment.Id] == undefined) {
			this._showSchool[studentEnrollment.Id] = studentEnrollment.SchoolName &&
				this.SchoolName &&
				studentEnrollment.SchoolName.trim().toUpperCase() != this.SchoolName.trim().toUpperCase();
		}

		// Returning our cached value
		return this._showSchool[studentEnrollment.Id];
	}

	getEntryDate() {
		// POST: obtains the entry date if it's valid (removing the junk date)
		if (this._entryDate == undefined) {
			if (this.EntryDate && this.EntryDate.toString() != System.junkDateString && this.EntryDate.toString() != System.junkDate.toString()) {
				this._entryDate = this.EntryDate;
			} else {
				this._entryDate = null;
			}
		}
		return this._entryDate;
	}

	getDroppedDate() {
		// POSt: obtains the dropped date if it's valid (removing the junk date)
		if (this._droppedDate == undefined) {
			if (this.DroppedDate && this.DroppedDate.toString() != System.junkDateString && this.DroppedDate.toString() != System.junkDate.toString()) {
				this._droppedDate = this.DroppedDate;
			} else {
				this._droppedDate = null;
			}
		}
		return this._droppedDate;
	}
}
